module.exports = __webpack_public_path__ + "static/media/operations-feature-2.390f47e3.svg";